import * as actionTypes from './actionTypes'

export const appLoading = () => ({
  type: actionTypes.APP_LOADING,
})

export const appSuccess = () => ({
  type: actionTypes.APP_SUCCESS,
})

export const appError = () => ({
  type: actionTypes.APP_ERROR,
})

export const appLoad = () => (dispatch) => {
  dispatch(appLoading())
    .then((response) => {
      dispatch(appSuccess())
    })
    .catch((error) => {
      dispatch(appError(error))
    })
}

export const setlanguage = (language) => ({
  type: actionTypes.SET_LANGUAGE,
  payload: language,

})

